import { StateSliceDefaults, StateSliceName } from '@oneapp/main/core/store.models';

export enum BundleNameFormControl {
    NAME = 'bundleNameControl'
}

export enum BundleDetailsCompanyFilterFormControlName {
    STRING_FILTER = 'stringFilter'
}

export interface BundleDetailsCompanyFormValues {
    [BundleDetailsCompanyFilterFormControlName.STRING_FILTER]:  string | undefined;
}

export const bundleDetailsDefaultFormValues: BundleDetailsCompanyFormValues = {
    [BundleDetailsCompanyFilterFormControlName.STRING_FILTER]: undefined
};

export enum BundleDetailsCompaniesTableColumn {
    NAME = 'name',
    CTA = 'cta'
}

export interface BundleDetailsCompaniesTableRow {
    [BundleDetailsCompaniesTableColumn.NAME]: string;
    /**
     * URL for company's page in OA
     */
    [BundleDetailsCompaniesTableColumn.CTA]:  string;
}

export enum BundleDetailsDataCySelector {
    BUNDLE_NAME_INPUT = 'bundle-name-input',
    BUNDLE_COMPANIES_FILTER_INPUT = 'companies-filter-input',
    BUNDLE_COMPANIES_TABLE = 'companies-table',
    BUNDLE_COMPANIES_TABLE_ROW = 'companies-table-row',
    BUNDLE_COMPANIES_TABLE_LINK_BUTTON = 'companies-table-link-button',
    BUNDLE_COMPANIES_TABLE_HEADER = 'companies-table-header',
    BUNDLE_COMPANIES_TABLE_COMPANY_NAME_CELL = 'companies-table-company-name-cell',
    BUNDLE_COMPANIES_NO_COMPANIES_MESSAGE = 'companies-no-companies-message',
    BUNDLE_COMPANIES_MODIFY_FILTERS_MESSAGE = 'companies-modify-filters-message',
    BUNDLE_COMPANIES_REFRESH_BUTTON = 'companies-refresh-button'
}

export interface BundleDetailsStateModel {
    companiesFormValues: BundleDetailsCompanyFormValues;
}

export const bundleDetailsStateDefaults: StateSliceDefaults<BundleDetailsStateModel> = Object.freeze({
    sliceName: StateSliceName.BUNDLE_DETAILS,
    defaults: {
        companiesFormValues: bundleDetailsDefaultFormValues
    }
});
